

var article = `
## Descargar SDK

* Ir a https://developer.android.com/studio.
* En la pestaña *Android Studio* y la subpestaña *Download*.
* Bajo hasta lo último donde dice **Command line tools only**.
* Y ahí descargo el archivo:

> commandlinetools-linux-xxxxxxx_latest.zip

## Instalar SDK

* Extraer la carpeta en el lugar más cómodo.
* Debe ser un lugar fijo y donde no moleste, por ejemplo, una carpeta llamada **Programas**.
* La carpeta por defecto se llamará **cmdline-tools**.
* La ruta completa debe ser algo así:

> /home/juan/Programas/cmdline-tools **(recordar)**

##### Antes de continuar

*Linux* me pedirá que **sdkmanager** (que es el comando) se encuentre dentro de la carpeta *latest*. No viene así por defecto y hay que hacerlo manualmente.

Solamente hay que crear una carpeta llamada *latest* dentro de la carpeta **cmdline-tools**. Y después pasar todos los archivos de ésta última a la nueva carpeta *latest* que, irónicamente, también estará dentro de **cmdline-tools**.

De manera que la ruta para llegar a los archivos quede así:

> /home/juan/Programas/cmdline-tools/latest

##### Continuando

* Ahora, posicionado en la *terminal* (Ctrl + Alt + T)

* Puedo hacer todo desde usuario **Root** (*opcional*):

> **juan@linux:~$** sudo su

* Hay que indicarle al **sistema** dónde está *escondido* el programa.
* Esto, con el fin de poder ejecutar los comandos *desde cualquier lugar* de la **terminal**.
* Es tan simple como hacer:

> **root@juan-linux#** export PATH:/home/juan/Programas/cmdline-tools/latest:/home/juan/Programas/cmdline-tools/latest/bin:$PATH

**NOTA:** hay que reemplazar las rutas del ejemplo con las orginales.

**NOTA:** las rutas se repiten, pero la primera vez que aparece termina en la *carpeta raiz* de todos los archivos **/latest**:

> **export PATH:**/home/juan/Programas/cmdline-tools/**latest** *[...]*

Después van dos puntos **:** y *se repite* pero esta vez termina en la carpeta **/bin**:

> *[...]* **:**/home/juan/Programas/cmdline-tools/latest/**bin**:$PATH

Seguido de **:$PATH** como se muestra arriba.

## Verificando que funciona

> sdkmanager --version

Si responde que no se reconoce el comando es porque no funciona. 

Si responde el número de versión significa que funciona:

> **8.0**, por ejemplo

Pero todavía falta algo **importante**.

## Guardar los cambios

Estos cambios no son permanentes y si cerramos sesión o reiniciamos desaparecerán, y tendremos que hacer todo otra vez para que vuelva a funcionar el comando **sdkmanager**.

Para guardar los cambios permanentemente tenemos que editar el archivo **.bashrc**

Es tan simple como hacer:

> **juan@linux:~$** sudo nano ~/.bashrc

Se abrirá el editor *nano* para editar dicho archivo.

**NOTA:** hay que ser *cuidadoso en estos archivos*, porque es fácil hacer cambios sin darse cuenta y después tener errores.

**NOTA:** si hice un **cambio indeseado**, tengo que cerrar el archivo *(Ctrl + X)* y seleccionar que *no quiero guardar los cambios*.

Con la flecha hacia abajo, bajo hasta el final del archivo*.

Y agrego:

> export PATH="/home/juan/Programas/cmdline-tools/latest/bin:$PATH"

Después cierro el archivo con *(Ctrl + X)*:

> ¿Guardar el búfer modificado?

* Elijo que **sí**.

> Nombre del archivo a escribir: /home/juan/.bashrc

* Presiono **Enter** para confirmar y reemplazar el archivo con los nuevos cambios.

**NOTA:** el archivo **.bashrc** se lee al inicio del sistema, por lo que abrá que reiniciar para ver si funciona correctamente. 

Después de *reiniciar* hago nuevamente:

> sdkmanager --version

Y si responde con el número de versión, significa que los cambios se **guardaron correcta y permanentemente**.

`

export default article
